import Model from "./abstract/Model";
import ContractCostDetermination from "./ContractCostDetermination"

export default class CostDetermination extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {
      'pivot': ContractCostDetermination,
    });
  }
}
